export class ArchiveLeadInput {
  leadsId: string[];
  archivedOption: string;
  comments: string;
  comingFromCallModal: boolean;
}
